const locationSearchPage = (function locationSearchPageModule() {
    let root;
    let listElement;
    let mapElement;
    let selectedBranchElement;
    let statusElement;
    let formElement;
    let inputElement;
    let mobileViewToggleButton;
    let mobileViewToggleLabel;
    let mobileViewToggleIcon;
    let useMyLocationButton;
    let searchEndpoint;
    let mobileBreakpoint;
    let defaultLatitude;
    let defaultLongitude;
    let ctaText;

    const state = {
        mode: 'loading',
        branches: [],
        selectedBranchName: null,
        latitude: null,
        longitude: null,
        showDistance: false,
        mobileView: 'list',
    };

    function setupElements() {
        root = document.querySelector('.location-search-page');

        if (!root) {
            return false;
        }

        listElement = root.querySelector('[data-branch-list]');
        mapElement = root.querySelector('[data-location-search-map]');
        selectedBranchElement = root.querySelector('[data-selected-branch]');
        statusElement = root.querySelector('[data-search-status]');
        formElement = root.querySelector('[data-search-form]');
        inputElement = document.getElementById('location-search-input');
        mobileViewToggleButton = root.querySelector('[data-mobile-view-toggle]');
        mobileViewToggleLabel = root.querySelector('[data-mobile-view-toggle-label]');
        mobileViewToggleIcon = root.querySelector('[data-mobile-view-toggle-icon]');
        useMyLocationButton = root.querySelector('[data-use-my-location]');
        mapUnavailableMessageElement = root.querySelector('[data-map-unavailable-message]');
        searchEndpoint = root.dataset.searchEndpoint || '/api/location-search/branches';
        mobileBreakpoint = Number(root.dataset.mapBreakpoint || 1024);
        defaultLatitude = Number(root.dataset.defaultLatitude);
        defaultLongitude = Number(root.dataset.defaultLongitude);
        ctaText = window.__locationSearchCtaText || 'View location';

        state.latitude = defaultLatitude;
        state.longitude = defaultLongitude;

        return true;
    }

    let map;
    let infoWindow;
    let markers = [];
    let centerMarker = null;
    let mapUnavailable = false;
    let mapUnavailableMessageElement;
    let mapErrorCheckTimeoutId = null;

    function isMobile() {
        return window.matchMedia(`(max-width: ${mobileBreakpoint}px)`).matches;
    }

    function setStatus(message) {
        if (statusElement) {
            statusElement.textContent = message || '';
        }
    }

    function getSelectedBranch() {
        return state.branches.find(item => item.name === state.selectedBranchName) || null;
    }

    function getEffectiveMobileView() {
        if (state.mobileView === 'selected' && !getSelectedBranch()) {
            return 'map';
        }

        return state.mobileView;
    }

    function updateMobileToggle() {
        if (!mobileViewToggleButton || !mobileViewToggleLabel || !mobileViewToggleIcon) {
            return;
        }

        const mobileView = getEffectiveMobileView();
        const showToggle = isMobile() && state.mode === 'results';

        mobileViewToggleButton.hidden = !showToggle;

        if (!showToggle) {
            return;
        }

        if (mapUnavailable) {
            const showMapButton = mobileView === 'list';
            const nextView = showMapButton ? 'map' : 'list';
            const label = showMapButton ? 'Map' : 'List';

            mobileViewToggleButton.dataset.targetView = nextView;
            mobileViewToggleButton.setAttribute('aria-label', `Show ${label.toLowerCase()} results`);
            mobileViewToggleLabel.textContent = label;
            mobileViewToggleIcon.classList.remove('location-search-page__mobile-toggle-icon--map', 'location-search-page__mobile-toggle-icon--list');
            mobileViewToggleIcon.classList.add(showMapButton ? 'location-search-page__mobile-toggle-icon--map' : 'location-search-page__mobile-toggle-icon--list');
            return;
        }

        const showMapButton = mobileView === 'list';
        const nextView = showMapButton ? 'map' : 'list';
        const label = showMapButton ? 'Map' : 'List';

        mobileViewToggleButton.dataset.targetView = nextView;
        mobileViewToggleButton.setAttribute('aria-label', `Show ${label.toLowerCase()} results`);
        mobileViewToggleLabel.textContent = label;
        mobileViewToggleIcon.classList.remove('location-search-page__mobile-toggle-icon--map', 'location-search-page__mobile-toggle-icon--list');
        mobileViewToggleIcon.classList.add(showMapButton ? 'location-search-page__mobile-toggle-icon--map' : 'location-search-page__mobile-toggle-icon--list');
    }

    function clearMapErrorCheck() {
        if (mapErrorCheckTimeoutId !== null) {
            window.clearTimeout(mapErrorCheckTimeoutId);
            mapErrorCheckTimeoutId = null;
        }
    }

    function containsGoogleMapError() {
        if (!mapElement) {
            return false;
        }

        return Boolean(mapElement.querySelector('.gm-err-container'));
    }

    function scheduleMapErrorCheck() {
        clearMapErrorCheck();

        if (mapUnavailable || !mapElement) {
            return;
        }

        mapErrorCheckTimeoutId = window.setTimeout(() => {
            mapErrorCheckTimeoutId = null;

            if (containsGoogleMapError()) {
                showMapUnavailable();
            }
        }, 400);
    }

    function renderSelectedBranch() {
        if (!selectedBranchElement) {
            return;
        }

        const showSelectedBranch = isMobile() && state.mode === 'results' && getEffectiveMobileView() === 'selected';
        const branch = getSelectedBranch();

        if (!showSelectedBranch || !branch) {
            selectedBranchElement.innerHTML = '';
            return;
        }

        selectedBranchElement.innerHTML = `
            <div class="location-search-page__selected-branch-panel">
                <button type="button"
                        class="location-search-page__selected-branch-close"
                        data-clear-selected-branch
                        aria-label="Close location details">
                    <span aria-hidden="true">×</span>
                </button>
                ${buildCard(branch, { selectable: false, overlay: true })}
            </div>`;
    }

    function syncRootClasses() {
        const showResults = state.mode === 'results';
        const showSelected = Boolean(state.selectedBranchName);
        const showMobileViews = isMobile() && showResults;
        const mobileView = getEffectiveMobileView();

        root.classList.toggle('location-search-page--loading', state.mode === 'loading');
        root.classList.toggle('location-search-page--results', showResults);
        root.classList.toggle('location-search-page--selected', showSelected);
        root.classList.toggle('location-search-page--mobile-list', showMobileViews && mobileView === 'list');
        root.classList.toggle('location-search-page--mobile-map', showMobileViews && mobileView === 'map');
        root.classList.toggle('location-search-page--mobile-selected', showMobileViews && mobileView === 'selected');
    }

    function applyViewState() {
        syncRootClasses();
        updateMobileToggle();
        renderSelectedBranch();
    }

    function setMode(mode) {
        state.mode = mode;
        applyViewState();
    }

    function escapeHtml(value) {
        return String(value || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function distanceText(distanceMiles) {
        if (!state.showDistance || typeof distanceMiles !== 'number') {
            return '';
        }

        return `${distanceMiles.toFixed(1)} mi`;
    }

    /**
     * Derives the display text for a single hours type (Lobby or Drive Thru)
     * based on the status object returned by the server.
     *
     * Returns:
     *   "Open until {closing time}"       – currently open
     *   "Opening at {opening time}"       – opens later today
     *   "Open tomorrow at {opening time}" – already closed, reopens tomorrow
     *   "Open {day} at {opening time}"    – already closed, reopens on a future day
     *   null                              – no hours data or status is overridden
     */
    function buildHoursStatusText(status) {
        if (!status || !status.hasHoursData || status.isStatusOverridden) {
            return null;
        }

        const detail = status.statusDetail || '';

        if (status.isOpenNow) {
            const match = detail.match(/^Closes at (.+)$/i);
            return match ? `Open until ${match[1]}` : null;
        }

        const todayMatch = detail.match(/^Opens today at (.+)$/i);
        if (todayMatch) {
            return `Opening at ${todayMatch[1]}`;
        }

        const tomorrowMatch = detail.match(/^Opens tomorrow at (.+)$/i);
        if (tomorrowMatch) {
            return `Open tomorrow at ${tomorrowMatch[1]}`;
        }

        const dayMatch = detail.match(/^Opens (\w+) at (.+)$/i);
        if (dayMatch) {
            return `Open ${dayMatch[1]} at ${dayMatch[2]}`;
        }

        return null;
    }

    function buildCard(branch, options = {}) {
        const { selectable = true, overlay = false, mapInfoWindow = false } = options;
        const selectedClass = !overlay && state.selectedBranchName === branch.name ? ' is-selected' : '';
        const overlayClass = overlay ? ' location-search-page__card--overlay' : '';
        const mapInfoWindowClass = mapInfoWindow ? ' location-search-page__card--map-info-window' : '';
        const branchNameEscaped = escapeHtml(branch.name);
        const detailsUrl = branch.detailsUrl ? String(branch.detailsUrl) : '';
        const isSelectable = selectable && Number.isFinite(branch.latitude) && Number.isFinite(branch.longitude);
        const selectableClass = isSelectable ? ' location-search-page__card--selectable' : '';
        const cardAttributes = isSelectable
            ? ` data-select-branch-card="${branchNameEscaped}" role="button" tabindex="0" aria-label="Select ${branchNameEscaped} on map"`
            : '';

        const addressHtml = (branch.addressLine || branch.cityStateZip)
            ? `<address class="location-search-page__address">${branch.addressLine ? `${escapeHtml(branch.addressLine)}<br>` : ''}${branch.cityStateZip ? escapeHtml(branch.cityStateZip) : ''}</address>`
            : '';

        const phoneHtml = branch.phone
            ? `<p class="location-search-page__phone"><a href="tel:${escapeHtml(branch.phone.replace(/[^\d+]/g, ''))}">${escapeHtml(branch.phone)}</a></p>`
            : '';

        // ── Today's Hours section ──────────────────────────────────────────
        const lobbyStatus = branch.lobbyStatus || null;
        const driveThruStatus = branch.driveThruStatus || null;
        const hasLobbyHours = !!(lobbyStatus && lobbyStatus.hasHoursData);
        const hasDriveThruHours = !!(driveThruStatus && driveThruStatus.hasHoursData);
        const showHoursSection = hasLobbyHours || hasDriveThruHours;

        const hoursHtml = (() => {
            if (!showHoursSection) {
                return '';
            }

            const lobbyText = hasLobbyHours ? buildHoursStatusText(lobbyStatus) : null;
            const driveThruText = hasDriveThruHours ? buildHoursStatusText(driveThruStatus) : null;

            const lobbyLine = (hasLobbyHours && lobbyText)
                ? `<p class="location-search-page__hours-line"><span class="location-search-page__hours-label">Lobby:</span> ${escapeHtml(lobbyText)}</p>`
                : '';

            const driveThruLine = (hasDriveThruHours && driveThruText)
                ? `<p class="location-search-page__hours-line"><span class="location-search-page__hours-label">Drive Thru:</span> ${escapeHtml(driveThruText)}</p>`
                : '';

            if (!lobbyLine && !driveThruLine) {
                return '';
            }

            return `<div class="location-search-page__hours"><p class="location-search-page__hours-heading">Today's Hours</p>${lobbyLine}${driveThruLine}</div>`;
        })();

        const servicesHtml = (() => {
            if (mapInfoWindow) {
                return '';
            }

            const services = branch.services;
            if (!services || services.length === 0) {
                return '';
            }
            return `<p class="location-search-page__services"><strong>Services:</strong> ${escapeHtml(services.join(', '))}</p>`;
        })();

        return `
            <article class="location-search-page__card${selectedClass}${selectableClass}${overlayClass}${mapInfoWindowClass}" data-branch-name="${branchNameEscaped}"${cardAttributes}>
                <div class="location-search-page__card-header">
                    <h2 class="location-search-page__card-title">${branchNameEscaped}</h2>
                    <span class="location-search-page__distance">${escapeHtml(distanceText(branch.distanceMiles))}</span>
                </div>
                ${hoursHtml}
                ${(addressHtml || phoneHtml) ? `<div class="location-search-page__contact">${addressHtml}${phoneHtml}</div>` : ''}
                ${servicesHtml}
                <div class="location-search-page__card-actions">
                    ${detailsUrl ? `<a href="${escapeHtml(detailsUrl)}" class="btn b-secondary">${escapeHtml(ctaText)}</a>` : ''}
                </div>
            </article>`;
    }

    function renderList() {
        if (!listElement) {
            return;
        }

        if (!state.branches.length) {
            listElement.innerHTML = '<p class="location-search-page__empty">No branches found for this search.</p>';
            return;
        }

        listElement.innerHTML = state.branches.map(buildCard).join('');

        listElement.querySelectorAll('[data-select-branch-card]').forEach(card => {
            card.addEventListener('click', event => {
                if (event.target instanceof Element && event.target.closest('a, button, input, select, textarea, label')) {
                    return;
                }

                const branchName = card.getAttribute('data-select-branch-card');
                if (branchName) {
                    selectBranch(branchName);
                }
            });

            card.addEventListener('keydown', event => {
                if (event.target && event.target !== card) {
                    return;
                }

                if (event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }

                event.preventDefault();
                const branchName = card.getAttribute('data-select-branch-card');
                if (branchName) {
                    selectBranch(branchName);
                }
            });
        });

        renderSelectedBranch();
    }

    function shouldRenderMap() {
        return state.mode === 'results' && (!isMobile() || getEffectiveMobileView() !== 'list');
    }

    function focusSelectedBranchOnMap(branch, shouldOpenInfoWindow) {
        if (!map || !branch || !Number.isFinite(branch.latitude) || !Number.isFinite(branch.longitude)) {
            return;
        }

        map.panTo({ lat: branch.latitude, lng: branch.longitude });

        if (!infoWindow) {
            return;
        }

        if (!shouldOpenInfoWindow) {
            infoWindow.close();
            return;
        }

        infoWindow.setContent(buildCard(branch, { selectable: false, overlay: true, mapInfoWindow: true }));

        const marker = markers.find(item => item.getTitle() === branch.name);
        if (marker) {
            infoWindow.open({ map, anchor: marker });
        }
    }

    function showMapUnavailable() {
        if (mapUnavailable) {
            return;
        }

        mapUnavailable = true;
        root.classList.add('location-search-page--map-unavailable');
        clearMapErrorCheck();

        markers.forEach(marker => marker.setMap(null));
        markers = [];

        if (centerMarker) {
            centerMarker.setMap(null);
            centerMarker = null;
        }

        if (mapUnavailableMessageElement) {
            mapUnavailableMessageElement.hidden = false;

            if (mapElement) {
                mapElement.replaceChildren(mapUnavailableMessageElement);
            }
        }

        // Close any open info window and prevent future map renders.
        if (infoWindow) {
            infoWindow.close();
        }

        map = null;

        // Ensure the mobile toggle is hidden (no map to switch to).
        updateMobileToggle();
    }

    function syncMap() {
        if (mapUnavailable || !window.google || !window.google.maps || !shouldRenderMap()) {
            if (infoWindow) {
                infoWindow.close();
            }

            return;
        }

        upsertMap();
        scheduleMapErrorCheck();

        const selectedBranch = getSelectedBranch();
        if (selectedBranch) {
            focusSelectedBranchOnMap(selectedBranch, !isMobile());
        } else if (infoWindow) {
            infoWindow.close();
        }
    }

    function upsertMap() {
        if (!window.google || !window.google.maps || !mapElement) {
            return;
        }

        if (!map) {
            map = new google.maps.Map(mapElement, {
                zoom: 10,
                center: { lat: state.latitude, lng: state.longitude },
            });
            infoWindow = new google.maps.InfoWindow({ maxWidth: 360 });
            map.addListener('click', () => {
                if (isMobile() && getEffectiveMobileView() === 'selected') {
                    clearSelectedBranch(true);
                }
            });
        } else {
            google.maps.event.trigger(map, 'resize');
        }

        // Clear previous branch markers and center marker.
        markers.forEach(marker => marker.setMap(null));
        if (centerMarker) {
            centerMarker.setMap(null);
            centerMarker = null;
        }

        // Place a distinct center-point marker for the searched location.
        centerMarker = new google.maps.Marker({
            map,
            position: { lat: state.latitude, lng: state.longitude },
            title: 'Search center',
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 9,
                fillColor: '#4285F4',
                fillOpacity: 1,
                strokeWeight: 2,
                strokeColor: '#ffffff',
            },
            zIndex: 1,
        });

        // Place branch markers.
        const branchesWithCoordinates = state.branches.filter(branch => Number.isFinite(branch.latitude) && Number.isFinite(branch.longitude));

        markers = branchesWithCoordinates.map(branch => {
            const marker = new google.maps.Marker({
                map,
                position: { lat: branch.latitude, lng: branch.longitude },
                title: branch.name,
            });

            marker.addListener('click', () => {
                selectBranch(branch.name);
            });

            return marker;
        });

        // Fit the viewport to contain the center point and all branch markers,
        // then clamp the zoom so we never zoom in too tightly.
        if (branchesWithCoordinates.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            bounds.extend({ lat: state.latitude, lng: state.longitude });
            branchesWithCoordinates.forEach(branch => {
                bounds.extend({ lat: branch.latitude, lng: branch.longitude });
            });
            map.fitBounds(bounds, /* padding */ 48);

            // After the map settles, prevent over-zooming on very dense clusters.
            google.maps.event.addListenerOnce(map, 'idle', () => {
                if (map.getZoom() > 14) {
                    map.setZoom(14);
                }
            });
        } else {
            map.setCenter({ lat: state.latitude, lng: state.longitude });
            map.setZoom(10);
        }
    }

    function showMobileList() {
        state.mobileView = 'list';
        applyViewState();
    }

    function showMobileMap() {
        state.mobileView = 'map';
        applyViewState();
        syncMap();
    }

    function clearSelectedBranch(showMapView = false) {
        if (!state.selectedBranchName) {
            return;
        }

        state.selectedBranchName = null;

        if (showMapView && isMobile()) {
            state.mobileView = 'map';
        }

        renderList();
        applyViewState();
        syncMap();
    }

    function selectBranch(branchName) {
        const branch = state.branches.find(item => item.name === branchName);
        if (!branch) {
            return;
        }

        state.selectedBranchName = branch.name;
        if (isMobile()) {
            state.mobileView = 'selected';
        }

        renderList();
        applyViewState();
        syncMap();
    }

    async function fetchBranches(latitude, longitude) {
        // Omit latitude/longitude params entirely when they are null/undefined so
        // the API falls back to the CMS-configured default location.
        const params = new URLSearchParams();
        if (typeof latitude === 'number' && isFinite(latitude) && typeof longitude === 'number' && isFinite(longitude)) {
            params.set('latitude', latitude);
            params.set('longitude', longitude);
        }

        const url = params.toString() ? `${searchEndpoint}?${params.toString()}` : searchEndpoint;
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error('Search request failed');
        }

        return response.json();
    }

    async function performSearch(latitude, longitude, statusText, showDistance = true) {
        try {
            const result = await fetchBranches(latitude, longitude);
            state.latitude = result.latitude;
            state.longitude = result.longitude;
            state.branches = result.branches || [];
            state.selectedBranchName = null;
            state.showDistance = showDistance;
            state.mobileView = 'list';

            setMode('results');
            setStatus(statusText);
            renderList();
            syncMap();
        } catch (error) {
            console.error(error);
            // Exit the loading state so the page does not appear stuck.
            setMode('results');
            setStatus('Unable to load nearby branches right now. Please try again later.');
        }
    }

    function geocodeQuery(query) {
        return new Promise((resolve, reject) => {
            if (!window.google || !window.google.maps) {
                reject(new Error('Google Maps is not ready'));
                return;
            }

            const geocoder = new google.maps.Geocoder();
            geocoder.geocode(
                {
                    address: query,
                    componentRestrictions: { country: 'US' },
                },
                (results, status) => {
                    if (status !== 'OK' || !results || !results[0]) {
                        reject(new Error(`Geocoding failed: ${status}`));
                        return;
                    }

                    resolve(results[0].geometry.location);
                });
        });
    }

    function requestBrowserLocation() {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('Geolocation is not supported'));
                return;
            }

            navigator.geolocation.getCurrentPosition(resolve, reject, {
                enableHighAccuracy: true,
                timeout: 5000,
            });
        });
    }

    async function loadInitialBranches() {
        // Ask the browser for the visitor's location.  If granted, search
        // around those coordinates.  If denied or unavailable, pass no
        // coordinates (null) so the API falls back to the default location.
        try {
            const position = await requestBrowserLocation();
			// Status can be put in te string below, e.g. Showing branches near your current location.
            await performSearch(position.coords.latitude, position.coords.longitude, '');
        } catch {
            // Browser location unavailable or denied – omit coordinates so the
            // API uses the CMS-configured default location as the center point.
			// Status can be put in te string below, e.g. Showing branches near the default area.
            await performSearch(null, null, '', false);
        }
    }

    function attachEvents() {
        if (formElement && inputElement) {
            formElement.addEventListener('submit', async event => {
                event.preventDefault();
                const query = inputElement.value.trim();

                if (!query) {
					// Status can be put in te string below, e.g. Showing branches near the map center.
					await performSearch(state.latitude, state.longitude, '');
                    return;
                }

                // If Google Maps is not available (e.g. no API key), fall back to the
                // current/default location rather than showing a misleading error.
                if (!window.google || !window.google.maps) {
                    setStatus('Location search by city or ZIP code is unavailable. Showing nearby branches.');
                    await performSearch(state.latitude, state.longitude, '');
                    return;
                }

                try {
                    const location = await geocodeQuery(query);
					// Status can be put in te string below, e.g. `Showing branches near \"${query}\".`
                    await performSearch(location.lat(), location.lng(), '');
                } catch (error) {
                    setStatus('We could not find that city/state or ZIP code.');
                }
            });
        }

        if (mobileViewToggleButton) {
            mobileViewToggleButton.addEventListener('click', () => {
                if (mobileViewToggleButton.dataset.targetView === 'map') {
                    showMobileMap();
                    return;
                }

                showMobileList();
            });
        }

        if (useMyLocationButton) {
            useMyLocationButton.addEventListener('click', async () => {
                try {
                    const position = await requestBrowserLocation();
					// Status can be put in te string below, e.g. Showing branches near your current location.
					await performSearch(position.coords.latitude, position.coords.longitude, '');
                } catch {
                    setStatus('Location permission was denied. Try entering a city/state or ZIP code.');
                }
            });
        }

        if (selectedBranchElement) {
            selectedBranchElement.addEventListener('click', event => {
                const closeButton = event.target instanceof Element
                    ? event.target.closest('[data-clear-selected-branch]')
                    : null;

                if (closeButton) {
                    clearSelectedBranch(true);
                }
            });
        }

        window.addEventListener('resize', () => {
            applyViewState();
            syncMap();
        });

        window.addEventListener('location-search:google-ready', () => {
            if (state.mode === 'results') {
                syncMap();
            }
        });

        window.addEventListener('location-search:map-unavailable', () => {
            showMapUnavailable();
        });
    }

    async function init() {
        if (!setupElements()) {
            return;
        }
        attachEvents();

        // If the server indicated no Maps API key, mark the map unavailable immediately.
        if (root.dataset.mapDisabled === 'true') {
            showMapUnavailable();
        }

        await loadInitialBranches();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

export { locationSearchPage };

